import { apiRequest } from "@/lib/queryClient";
import type { ValidateTweetResponse } from "@/types/xdao";

export const twitterApi = {
  /**
   * Validate tweet and auto-join partner if valid
   * @param partnerId - Partner ID to join
   * @param tweetUrl - Full Twitter/X URL to the tweet
   * @param projectId - Project ID with validation criteria
   */
  validateAndJoin: async (
    partnerId: number,
    tweetUrl: string,
    projectId: number
  ): Promise<ValidateTweetResponse> => {
    return apiRequest<ValidateTweetResponse>(
      "POST",
      `/api/v1/twitter/validate-join/${partnerId}`,
      {
        tweetUrl,
        projectId,
      }
    );
  },
};
